@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Teren objęty wnioskiem
    </h3>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Dane określające w sposób jednoznaczny nieruchomość</strong>
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Wojewódstwo:">
              {{ application?.voivodeship || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Powiat:">
              {{ application?.county || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Gmina:">
              {{ application?.municipality || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Kod pocztowy:">
              {{ application?.postalCode || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Poczta:">
              {{ application?.postOffice || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Miejscowość:">
              {{ application?.city || '-' }}
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Ulica:">
              {{ application?.street || '-' }}
            </app-label>
          </div>
          <div class="col-md-2">
            <app-label label="Nr Domu:">
              {{ application?.houseNumber || '-' }}
            </app-label>
            @if (application?.apartmentNumber; as apartmentNumber) {
              &nbsp;
              <app-label label="Nr mieszkania:">
                {{ apartmentNumber || '-' }}
              </app-label>
            }
          </div>
        </div>
      </dd>
    </dl>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Działki</strong>
      </dt>
      <dd>
        <app-parcels-preview [parcels]="parcels || []"></app-parcels-preview>
      </dd>
    </dl>
    <br>
    <h3>
      Charakterystyka inwestycji
    </h3>
    <div class="row">
      <div class="col-12">
        <app-label label="Nazwa inwestycji:">
          {{ application?.investmentName || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Sposób wyznaczenia terenu inwestycji:">
          {{ application?.investmentAreaDesignation || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="Powierzchnia terenu inwestycji, w przypadku gdy teren inwestycji obejmuje część co najmniej jednej działki ewidencyjnej:">
          {{ (application?.investmentAreaSize) | number }} (m<sup>2</sup>)
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="W przypadku gdy inwestycja dotyczy istniejącej zabudowy i zagospodarowania terenu, istniejąca zabudowa:">
          {{ application?.existingDevelopment || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Obecny sposób zagospodarowania terenu inwestycji:">
          {{ application?.currentLandUse || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Projektowany sposób zagospodarowania terenu inwestycji:">
          {{ application?.plannedLandUse || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="Sposób oddziaływania, w przypadku gdy obszar oddziaływania obiektu wykracza poza teren inwestycji:">
          {{ application?.impactDescription || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="Dane charakteryzujące wpływ inwestycji na środowisko, w szczególności określenie rodzaju przedsięwzięcia w nawiązaniu do przepisów odrębnych, w przypadku gdy inwestycja zalicza się do przedsięwzięć mogących znacząco oddziaływać na środowisko:">
          {{ application?.environmentalImpactData || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <div class="col-12">
      <p class="mb-2">
        <strong>
          Parametry dotyczące terenu inwestycji:
        </strong>
      </p>
    </div>
    <dl>
      <dt>
        Powierzchnia zabudowy:
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Istniejąca:">
              {{ application?.buildingAreaExisting | number }} (m<sup>2</sup>)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, minimalna:">
              {{ application?.buildingAreaPlannedMin | number }} (m<sup>2</sup>)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, maksymalna:">
              {{ application?.buildingAreaPlannedMax | number }} (m<sup>2</sup>)
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <dl>
      <dt>
        Powierzchnia biologicznie czynna:
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Istniejąca:">
              {{ application?.biologicalAreaExisting | number }} (m<sup>2</sup>)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, minimalna:">
              {{ application?.biologicalAreaPlannedMin | number }} (m<sup>2</sup>)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, maksymalna:">
              {{ application?.biologicalAreaPlannedMax | number }} (m<sup>2</sup>)
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <dl>
      <dt>
        Powierzchnia podlegająca przekształceniu:
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Istniejąca:">
              {{ application?.transformationAreaExisting | number }} (m<sup>2</sup>)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, minimalna:">
              {{ application?.transformationAreaPlannedMin | number }} (m<sup>2</sup>)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, maksymalna:">
              {{ application?.transformationAreaPlannedMax | number }} (m<sup>2</sup>)
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <dl>
      <dt class="mb-2">
        Czy inwestycja dotyczy:
      </dt>
      <dd>
        <div class="row">
          <div class="col-12">
            <app-label label="Wolnostojącego, nie więcej niż dwukondygnacyjnego budynku mieszkalnego
                              jednorodzinnego o powierzchni zabudowy do 70 m², o którym mowa w art. 29 ust. 1 pkt
                              1a ustawy z dnia 7 lipca 1994 r. – Prawo budowlane (Dz. U. z 2023 r. poz. 682, z późn. zm.):">
              {{ application?.isSmallHouse70m2 ? 'Tak' : 'Nie' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label label="Biogazowni rolniczej spełniającej warunki określone w art. 4 ust. 1 ustawy z dnia 13 lipca
                              2023 r. o ułatwieniach w przygotowaniu i realizacji inwestycji w zakresie biogazowni
                              rolniczych, a także ich funkcjonowaniu (Dz. U. poz. 1597):">
              {{ application?.isAgriculturalBiogas ? 'Tak' : 'Nie' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label label="Strategicznej inwestycji w zakresie sieci dystrybucyjnej, o której mowa w art. 1 ust. 2
                              pkt 4a ustawy z dnia 24 lipca 2015 r. o przygotowaniu i realizacji strategicznych inwestycji
                              w zakresie sieci przesyłowych (Dz. U. z 2023 r. poz. 1680, z późn. zm.):">
              {{ application?.isStrategicGridInvestment ? 'Tak' : 'Nie' }}
            </app-label>
          </div>
          <div class="col-12">
            <app-label label="Zakładu o zwiększonym lub dużym ryzyku wystąpienia poważnej awarii przemysłowej,
                              o którym mowa w art. 248 ust. 1 ustawy z dnia 27 kwietnia 2001 r. – Prawo ochrony
                              środowiska (Dz. U. z 2024 r. poz. 54):">
              {{ application?.isIndustrialHazardFacility ? 'Tak' : 'Nie' }}
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <div class="row">
      <div class="col-12">
        <app-label
          label="Łączna powierzchnia sprzedaży, w przypadku gdy inwestycja dotyczy obiektu handlowego:">
          {{ application?.totalSalesOrUsableArea | number }} (m<sup>2</sup>)
        </app-label>
      </div>
      <div class="col-12">
        <app-label
          label="Powierzchnia gospodarstwa rolnego, w przypadku gdy inwestycja jest związana z gospodarstwem rolnym:">
          {{ application?.totalSalesOrUsableArea | number }} (m<sup>2</sup>)
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Dodatkowe informacje dotyczące terenu inwestycji:">
          {{ application?.investmentAreaAdditionalInfo || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Obsługa komunikacyjna
    </h3>
    <div class="row">
      <div class="col-12">
        <app-label label="Dostęp do drogi publicznej:">
          {{ application?.publicRoadAccess || '-' }}
        </app-label>
      </div>
    </div>
    <dl class="mb-4">
      <dt class="mb-3">
        <strong>Dostęp do drogi publicznej poprzez działki</strong>
      </dt>
      <dd>
        <app-parcels-preview [parcelId]="true" [parcels]="parcels2 || []"></app-parcels-preview>
      </dd>
    </dl>
    <br>
    <div class="row">
      <div class="col-12">
        <app-label label="Dodatkowe informacje dotyczące dostępu do drogi publicznej:">
          {{ application?.publicRoadAccessAdditionalInfo || '-' }}
        </app-label>
      </div>
    </div>
    <div class="col-12">
      <p class="mb-2">
        <strong>
          Parametry dotyczące terenu inwestycji:
        </strong>
      </p>
    </div>
    <dl>
      <dt>
        Garaż:
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Istniejąca:">
              {{ application?.garageParkingExisting || '-' }} (szt)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, minimalna:">
              {{ application?.garageParkingPlannedMin || '-' }} (szt)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, maksymalna:">
              {{ application?.garageParkingPlannedMax || '-' }} (szt)
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <dl>
      <dt>
        Parking:
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Istniejąca:">
              {{ application?.parkingLotExisting || '-' }} (szt)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, minimalna:">
              {{ application?.parkingLotPlannedMin || '-' }} (szt)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, maksymalna:">
              {{ application?.parkingLotPlannedMax || '-' }} (szt)
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <dl>
      <dt>
        Inne:
      </dt>
      <dd>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Istniejąca:">
              {{ application?.otherParkingExisting || '-' }} (szt)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, minimalna:">
              {{ application?.otherParkingPlannedMin || '-' }} (szt)
            </app-label>
          </div>
          <div class="col-md-4">
            <app-label label="Projektowana, maksymalna:">
              {{ application?.otherParkingPlannedMax || '-' }} (szt)
            </app-label>
          </div>
        </div>
      </dd>
    </dl>
    <br>
    <div class="row">
      <div class="col-12">
        <app-label label="Dodatkowe informacje dotyczące miejsc do parkowania:">
          {{ application?.parkingAdditionalInfo || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
